























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {StateViewModel} from '@/features/bots/models/designer';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import IslandBadge from './IslandBadge.vue';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';

@Component({
	components: {
		IslandBadge,
		ErrorIcon,
		TextEditor
	},
	mixins: [validationMixin],
	validations: {
		state: {
			text: {
				required,
				attributeInvalid(value) {
					const textComponent = (this as any);
					const invalidAttribute: boolean = textComponent.invalidAttribute;
					return !invalidAttribute;
				}
			}
		}
	}
})
export default class TextComponent extends Vue {
	@Prop() public value: StateViewModel;
	public state: StateViewModel = {
		id: '',
		component: 'Text'
	};

	public $refs: {
		textEditor: TextEditor
	};

	public invalidAttribute: boolean = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: StateViewModel, previous: StateViewModel) {
		this.state = value;
	}

	public async textUpdated(text: string) {
		if (this.state.text === text) {
			return;
		}
		this.state.text = text;

		this.$v.$touch();
		this.state.invalid = this.$v.$invalid;

		this.$emit('state-updated', this.state);
	}

	public setInvalidAttribute(val: boolean) {
		this.invalidAttribute = val;
		this.$v.$touch();
		this.state.invalid = this.$v.$invalid;
	}

	public focusOnInput() {
		this.$refs.textEditor.focusElement();
		this.$refs.textEditor.startEditing();
	}

}
